import * as React from "react"
import Layout from "../Components/Layout";

export default function Disclaimer() {
  return (
    <main>
      <title>Fietsen Marijnissen :: Koop een fiets bij de man die hem ook vakkundig herstellen kan!</title>
      <Layout>
      <h1>Disclaimer</h1>
<p>De inhoud van onze website is met de grootste zorg samengesteld. De ervaring heeft echter geleerd dat het ondanks de betrachte zorgvuldigheid kan voorkomen dat de informatie op deze website verouderd is of onjuistheden bevat.</p>

<p>Fietsen Marijnissen is in geen geval aansprakelijk voor enige schade die het directe of indirecte gevolg is van of in verband staat met het gebruik van de op deze website beschikbare informatie.</p>      </Layout>
    </main>
  );
}
